import { render, staticRenderFns } from "./dropdown-main.vue?vue&type=template&id=9d8e683e&"
import script from "./dropdown-main.vue?vue&type=script&lang=ts&"
export * from "./dropdown-main.vue?vue&type=script&lang=ts&"
import style0 from "./dropdown-main.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports